module.exports = __webpack_public_path__ + "media/images/bondform_others-9181d7ead29cfb52dfc661730c111c2c.gif";